import useParentId from '@/modules/plan/PlanSetup/hooks/useParentId.ts';
import { useStore as useAdditionalStore } from '@/modules/plan/PlanSetup/PlanDefinition/Additional/stores/useAdditional.store';

import { useSearchParams } from '../hooks';
import { useGetEligibleServicesListQuery } from '../queries';
import { useGetParentEligibleServicesListQuery } from '../queries';

import { useSyncSpendLimits } from './useSyncSpendLimits';

export const useEligibleServicesActions = () => {
  const parentId = useParentId();

  const perCategorySpendLimit = useAdditionalStore((state) => state.state.perCategorySpendLimit);

  const {
    sortParams,
    sortOptions,
    searchString,
    setSearchString,
    setSortParams,
    params,
    serviceTypeParamsValues,
    setServiceType,
    categoriesParamsValues,
    setCategories,
  } = useSearchParams();

  const {
    formattedData: childFormattedData,
    total: childTotal,
    isLoading: childLoading,
  } = useGetEligibleServicesListQuery(params, parentId);

  const {
    formattedData: parentFormattedData,
    total: parentTotal,
    isLoading: parentLoading,
  } = useGetParentEligibleServicesListQuery(params, parentId);

  const formattedData = parentId ? parentFormattedData : childFormattedData;
  const total = parentId ? parentTotal : childTotal;
  const isLoading = parentId ? parentLoading : childLoading;

  useSyncSpendLimits(formattedData);

  return {
    sortParams,
    sortOptions,
    searchString,
    setSearchString,
    setSortParams,
    params,
    serviceTypeParamsValues,
    setServiceType,
    categoriesParamsValues,
    setCategories,
    formattedData,
    total,
    isLoading,
    parentId,
    perCategorySpendLimit,
  };
};
